import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Button, Input } from 'antd';
import React from 'react';


const LocationBuskDetailStock = ({id , location}:{id:number,location:string[]}) => {
  return (
    <div
      className="wrapLocation"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '19px'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '19px' }}>
        Location
        <Input value={id} style={{ display: 'inline-block', width: '100%' }} />
        <Input value={(location && location.length >0 ? location[0] : "")} style={{ display: 'inline-block', width: '100%' }} />
      </div>
    </div>
  );
};

export default LocationBuskDetailStock;
